import { render, staticRenderFns } from "./BigLoader.vue?vue&type=template&id=722cccdf"
import script from "./BigLoader.vue?vue&type=script&lang=js"
export * from "./BigLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports